import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.includes.js";
import { __decorate } from "tslib";
import CenterCenter from '@/components/layout/CenterCenter.vue';
import MainTitle from '@/components/title/MainTitle.vue';
import store from '@/store';
import { router } from "@/router";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { AUTH_REQUEST, AuthParams } from '@/store/actions/auth';
import ConfirmDialog from "@/components/dialog/ConfirmDialog.vue";
var LoginView = /*#__PURE__*/function (_Vue) {
  function LoginView() {
    var _this;
    _classCallCheck(this, LoginView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LoginView, [].concat(args));
    _defineProperty(_this, "login", void 0);
    _defineProperty(_this, "password", void 0);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "isComponentMounted", false);
    _defineProperty(_this, "initializationMode", void 0);
    return _this;
  }
  _inherits(LoginView, _Vue);
  return _createClass(LoginView, [{
    key: "mounted",
    value: function mounted() {
      this.isComponentMounted = true;
      this.initializationMode = this.$route.path.includes('update') ? 'password_update' : 'default';
    }
  }, {
    key: "autoLogin",
    value: function autoLogin() {
      var _this2 = this;
      this.errorMsg = '';
      this.loading = true;
      var params = new AuthParams(this.login, this.password, true);
      store.dispatch(AUTH_REQUEST, params).then(function () {
        router.push('/');
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }]);
}(Vue);
__decorate([Prop()], LoginView.prototype, "login", void 0);
__decorate([Prop()], LoginView.prototype, "password", void 0);
LoginView = __decorate([Options({
  components: {
    MainTitle: MainTitle,
    CenterCenter: CenterCenter,
    ConfirmDialog: ConfirmDialog
  }
})], LoginView);
export default LoginView;